export const OrganizationSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://navatel.ir/#organization",
      "name": "شبکه گستران آریا سامانه",
      "alternateName": "نواتل",
      "url": "https://navatel.ir/",
      "logo": {
        "@type": "ImageObject",
        "url": "https://navatel.ir/_ipx/q_80&s_150x72/img/logo-modal.webp",
        "width": 150,
        "height": 72
      },
      "foundingDate": "2001",
      "description": "شرکت دانش بنیان «شبکه گستران آریا سامانه» از سال ۱۳۸۰ فعالیت خود را آغاز کرد و با برند «نواتل» به عنوان اولین ارائه‌دهنده سرویس ارتباط یکپارچه ابری (UCaaS) در ایران شناخته می‌شود.",
      "telephone": "+98-21-82800000",
      "sameAs": [
        "https://www.linkedin.com/company/navatel/",
        "https://www.instagram.com/navatel.ir/",
        "https://twitter.com/navatel_ir",
        "https://t.me/navatel"
      ]
    },
    {
      "@type": "AboutPage",
      "url": "https://navatel.ir/about-us/",
      "name": "درباره نواتل | پیشرو در ارائه راهکارهای ابری",
      "mainEntity": {
        "@id": "https://navatel.ir/#organization"
      }
    }
  ]
}
